@if (user) {
  <div id="wait_on_load">
    <header class="baer-header">
      <div class="breadcrumb">@if (user?.baer_roles?.length > 0) {
        <span><a routerLink="/roster">All Users</a> &gt; </span>
      }{{user.first_name}} {{user.last_name}}</div>
      <div class="title_user">
        <div class="user-icon">
          <p>{{user.first_name[0]}}</p>
        </div>
        <div class="user-cell-details">
          <p id="table" class="site-page-title">{{user.first_name}} {{user.last_name}}</p>
          <mat-chip>User</mat-chip>
          @if (selfEditable && !user.filteredAssessment) {
            <mat-chip class="availability-check">
              <span class="before_dd">
                @if (available_personal == 'true') {
                  <mat-icon class="icon_available">check</mat-icon>
                }
                @if (available_personal == 'false') {
                  <mat-icon class="icon_not">block</mat-icon>
                }
              </span>
              <mat-form-field appearance="outline" class="availability-dd">
                <mat-select [(value)]="available_personal" (selectionChange)="availabilityChanged()" [disabled]="!selfEditable">
                  <mat-option value="true"><mat-icon class="icon_available_dd">check</mat-icon> Available for Assignment</mat-option>
                  <mat-option value="false"><mat-icon class="icon_not_dd">block</mat-icon> Not Available</mat-option>
                </mat-select>
              </mat-form-field>
            </mat-chip>
          }
          @if (user.filteredAssessment) {
            <mat-chip style="margin-left: 10px;"><mat-icon class="icon_assign">circle</mat-icon> On Assignment <mat-icon class="icon_info"
          [matTooltip]="user.assessmentTooltip" matTooltipClass="tooltipClass">info_outlined</mat-icon></mat-chip>
        }
        @if (!selfEditable && !user.filteredAssessment && available_personal) {
          <mat-chip style="margin-left: 10px;"><mat-icon class="icon_available">check</mat-icon> Available for Assignment</mat-chip>
        }
        @if (!selfEditable && !user.filteredAssessment && !available_personal) {
          <mat-chip style="margin-left: 10px;"><mat-icon class="icon_not">block</mat-icon> Not Available</mat-chip>
        }
      </div>
    </div>
  </header>
  @if (!edit_contact()) {
    <div class="contact_card">
      <app-view-contact [(edit_contact)]="edit_contact" [user]="user" [editable]="editable"></app-view-contact>
    </div>
  }
  @if (edit_contact()) {
    <div class="contact_card">
      <app-edit-contact [(edit_contact)]="edit_contact" [user]="user" [refreshUser]="refreshUser"></app-edit-contact>
    </div>
  }
  <div class="positions_card"><app-view-positions [positionList]="positionList"></app-view-positions></div>
  <div class="assignments_card" id="assignments"><app-view-assignments [assignmentList]="assignmentList" (loaded)="subLoaded()"></app-view-assignments></div>
  @if (!edit_availability()) {
    <div class="availability_card">
      <app-view-availability [(edit_availability)]="edit_availability" [user]="user" [editable]="selfEditable || isAdmin"></app-view-availability>
    </div>
  }
  @if (edit_availability()) {
    <div class="availability_card">
      <app-edit-availability [(edit_availability)]="edit_availability" [user]="user" [refreshUser]="refreshUser" [editable]="selfEditable"></app-edit-availability>
    </div>
  }
  @if (!edit_skills()) {
    <div class="skills_card">
      <app-view-skills [(edit_skills)]="edit_skills" [user]="user" [editable]="selfEditable || isAdmin"></app-view-skills>
    </div>
  }
  @if (edit_skills()) {
    <div class="skills_card">
      <app-edit-skills [(edit_skills)]="edit_skills" [user]="user" [refreshUser]="refreshUser"></app-edit-skills>
    </div>
  }
</div>
}
